(() => {
  const wrapper = document.getElementById('ProductDetailsTable');
  if (!wrapper) return;

  const getVariantId = () => {
    const input = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    return input?.value || null;
  };

  let lastId = null;
  let timer = null;

  const reloadDetails = async () => {
    const variantId = getVariantId();
    if (!variantId || variantId === lastId) return;

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variantId);

    try {
      const res = await fetch(url.toString(), {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.getElementById('ProductDetailsTable');

      if (fresh) {
        wrapper.innerHTML = fresh.innerHTML;
        lastId = variantId;
      }
    } catch (e) {
      console.error('Variant details reload failed', e);
    }
  };

  const scheduleReload = () => {
    clearTimeout(timer);
    timer = setTimeout(reloadDetails, 80);
  };

  document.addEventListener('change', (e) => {
    if (e.target.closest('form[action*="/cart/add"]')) {
      scheduleReload();
    }
  });

  // initial load
  scheduleReload();
})();
